export enum BUTTON_VARIANT {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  NEGATIVE = 'NEGATIVE',
  LOGIN = 'LOGIN',
  LOGIN_SECONDARY = 'LOGIN_SECONDARY',
}
